import { useLocation } from 'react-router-dom'

import { hasDebugQueryParam } from './debugQuery'
import { useProductRefreshAlphaEnabled } from '../product_refresh/useProductRefreshAlphaEnabled'

/**
 * Shared App Shell debug popover visibility.
 * Requires `?debug=true` and alpha cohort — beta-only users never see the panel.
 */
export function useShowDebugToolsPanel(): boolean {
  const { search } = useLocation()
  const isAlpha = useProductRefreshAlphaEnabled()

  return hasDebugQueryParam(search) && isAlpha
}
